// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"2924739e","108":"6b5155cb","128":"53391bd7","452":"8d3ded04","453":"e6deb9bf","482":"c10a7c93","672":"101f7f89","868":"b28ab077"}[chunkId] + ".chunk.js";
};